export function useUpgradeOptions() {
    const clearUpgradeOptions = () => {
        localStorage.removeItem('upgrade_source');
        localStorage.removeItem('upgrade_type');
        localStorage.removeItem('upgrade_url');
        localStorage.removeItem('upgrade_source_data');
        localStorage.removeItem('upgrade_source_id');
        localStorage.removeItem('upgrade_source_type');

        console.log('++ Clear Upgrade Options');
    }

    // Make it available globally for components that need window.clearUpgradeOptions
    if (typeof window !== 'undefined') {
        window.clearUpgradeOptions = clearUpgradeOptions
    }

    return {
        clearUpgradeOptions
    }
}
